var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{staticClass:"ma-0 pa-0"},[_c('p',{staticClass:"ma-0 pa-0"},[_vm._v(_vm._s(_vm.$t('appbar.languageString'))+": "),_c('span',{staticClass:"clickable-cursor",style:(_vm.styleIt),on:{"click":_vm.setIt}},[_vm._v("IT")]),_vm._v(" | "),_c('span',{staticClass:"clickable-cursor",style:(_vm.styleEn),on:{"click":_vm.setEn}},[_vm._v("EN")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }